export const triggerSources = {
  SAVE_AND_CONTINUE: 'saveAndContinue',
  SAVE_AND_EXIT: 'saveAndExit',
  SAVE_PREVENT_MODAL: 'savePreventModal'
};
